import React from "react";
import useCallCenterT from "../../hooks/useCallCenterT";
import { hasScreenAccess } from "../../utils/permissions";
import AgentSlaSettings from "../../components/call-center/AgentSlaSettings";

const CallCenterSlaSettingsPage = () => {
  const t = useCallCenterT();
  const canEdit = hasScreenAccess("CC_SETTINGS", "canUpdate");

  return (
    <div className="min-h-screen bg-[#f4f7fb] px-4 py-6 sm:px-6">
      <header className="mb-5">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">{t("ccSlaSettingsPageTitle")}</h1>
        <p className="mt-1 text-sm text-slate-500">{t("ccSlaSettingsPageSubtitle")}</p>
      </header>

      <section className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm">
        <div className="border-b border-slate-100 px-5 py-4 sm:px-6">
          <h2 className="text-sm font-semibold text-slate-900">{t("ccSlaThresholdsTitle")}</h2>
          <p className="mt-0.5 text-sm text-slate-500">{t("ccSlaThresholdsSubtitle")}</p>
        </div>
        <div className="px-5 py-5 sm:px-6">
          <AgentSlaSettings canEdit={canEdit} />
        </div>
      </section>
    </div>
  );
};

export default CallCenterSlaSettingsPage;
